import React from 'react';
import { CircularProgress } from '@mui/material';

const PdfExportsByTool = ({ loading, stats }) => {
  const rows = stats?.exportsByTool || [];

  return (
    <div className="pdfTableGrid pdfToolTableGrid">
      <div className="pdfTableGridHeader">
        <div className="pdfTableGridCell">Tool</div>
        <div className="pdfTableGridCell">Total</div>
        <div className="pdfTableGridCell">Success</div>
        <div className="pdfTableGridCell">Failed</div>
      </div>
      {loading ? (
        <div style={{ padding: '1rem' }}>
          <CircularProgress size={24} />
        </div>
      ) : (
        rows.map((row) => (
          <div className="pdfTableGridRow" key={row._id}>
            <div className="pdfTableGridCell">{row._id}</div>
            <div className="pdfTableGridCell">{row.total}</div>
            <div className="pdfTableGridCell">{row.success}</div>
            <div className="pdfTableGridCell">{row.failed}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default PdfExportsByTool;
